function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M43.49 21.15A12 12 0 0133.67 40h-16a16 16 0 115.69-30.92A12 12 0 0134.67 1a12.36 12.36 0 012.21.21A8 8 0 0036.67 3a8 8 0 008 8 8.12 8.12 0 001.79-.21 12.36 12.36 0 01.21 2.21 11.91 11.91 0 01-3.18 8.15zM5.68 24a12 12 0 0012 12h16a8 8 0 10-4.33-14.7A12 12 0 005.68 24zM25.23 9.94zm7.65-4.7A8 8 0 0027 11a16.05 16.05 0 014.68 5.22 12.36 12.36 0 012-.21 11.89 11.89 0 017 2.28 8 8 0 001.78-3.49 12 12 0 01-9.58-9.56z"
});

var SvgPartlyCloudyNight = function SvgPartlyCloudyNight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 48.16 41.5",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPartlyCloudyNight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/partly-cloudy-night.ca583eb3.svg";
export { ForwardRef as ReactComponent };